<template>
  <div class="getLabel">
     <img class="flowPathPicture" src="../../assets/images/home/label.png" alt="">
  </div>
</template>
<script>
export default {
  name: '', 
  mixins: [],
  components: {
  },
  data() {
    return {
    };
  },
  async mounted() {
  },
  methods: {
  },
}
</script>
<style lang='scss' scoped>
.flowPathPicture{
  width: 100%;
}
</style>